module.exports = __webpack_public_path__ + "img/pr-6.13128972.png";